import React, {ReactNode} from 'react';

import {Helmet} from 'react-helmet-async';

import {ErrorBoundary} from '@shared/ui/ErrorBoundary';

interface PageProps {
    children: ReactNode;
    title?: string;
}

export const Page = ({children, title}: PageProps) => (
    <>
        <Helmet>
            <title>{title || 'traceCORE B2B E-Invoicing'}</title>
        </Helmet>

        <ErrorBoundary>{children}</ErrorBoundary>
    </>
);
